<div class="client_info_page">
	<h3 class="backToClientsPage">
		<a href="javascript:void();" (click)="changeTab.emit()">
			<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
				<path d="M25.3333 16H6.66666M6.66666 16L16 25.3333M6.66666 16L16 6.66667" stroke="black"
					stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
			</svg>
		</a>
		{{ clientDetail.full_name }}
	</h3>

	<div *ngIf="activeTab == 'edit-client'">
		<form [formGroup]="clientForm" (ngSubmit)="submitted=true; submit()">
			<div class="client_info_page_header pb-4">
				<div class="d-flex flex-column flex-sm-row align-items-center gap-4">
					<button class="primary_btn editItem">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
							<path d="M18 10L14 6M2.5 21.5L5.88437 21.124C6.29786 21.078 6.5046 21.055 6.69785 20.9925C6.86929 20.937 7.03245 20.8586 7.18289 20.7594C7.35245 20.6475 7.49955 20.5005 7.79373 20.2063L21 7C22.1046 5.89543 22.1046 4.10457 21 3C19.8955 1.89543 18.1046 1.89543 17 3L3.79373 16.2063C3.49955 16.5005 3.35246 16.6475 3.24064 16.8171C3.14143 16.9676 3.06301 17.1307 3.00751 17.3022C2.94496 17.4954 2.92198 17.7021 2.87604 18.1156L2.5 21.5Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<span i18n="@@services.update"> Update</span>
					</button>
					<div class="secondary_btn" (click)="deleteClient()">
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
							<path d="M13.3333 5V4.33333C13.3333 3.39991 13.3333 2.9332 13.1517 2.57668C12.9919 2.26308 12.7369 2.00811 12.4233 1.84832C12.0668 1.66667 11.6001 1.66667 10.6667 1.66667H9.33333C8.39991 1.66667 7.9332 1.66667 7.57668 1.84832C7.26308 2.00811 7.00811 2.26308 6.84832 2.57668C6.66667 2.9332 6.66667 3.39991 6.66667 4.33333V5M2.5 5H17.5M15.8333 5V14.3333C15.8333 15.7335 15.8333 16.4335 15.5608 16.9683C15.3212 17.4387 14.9387 17.8212 14.4683 18.0608C13.9335 18.3333 13.2335 18.3333 11.8333 18.3333H8.16667C6.76654 18.3333 6.06647 18.3333 5.53169 18.0608C5.06129 17.8212 4.67883 17.4387 4.43915 16.9683C4.16667 16.4335 4.16667 15.7335 4.16667 14.3333V5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<span i18n="@@dashboard.delete"> Delete </span>
					</div>
				</div>
			</div>
			<div class="client_info_block">
				<span i18n="@@clients.client_info">Client Info</span>
				<div class="client_info_grid">
					<div>
						<label for="firstName" i18n="@@clients.first_name">First Name<span class="req-star" style="display: unset;">*</span></label>
						<fieldset [ngClass]="{ 'has-error': (submitted || clientForm.get('first_name').dirty) && clientForm.get('first_name')?.errors }">
							<input type="text" name="first_name" formControlName="first_name" placeholder="First Name">
							<span class="field-error" i18n="@@clients.validation.first_name_required" *ngIf="(submitted || clientForm.get('first_name').dirty) && clientForm.get('first_name').errors?.required">First name is required</span>
							<span class="field-error" i18n="@@validation.errors.enter_valid_first_name" *ngIf="(submitted || clientForm.get('first_name').dirty) && clientForm.get('first_name').errors?.pattern">Please enter valid first name</span>
							<span class="field-error" i18n="@@validation.errors.first_name_less_than_100_character" *ngIf="(submitted || clientForm.get('first_name').dirty) && clientForm.get('first_name').errors?.maxlength">First name must be less than 100 characters</span>
							<span class="field-error" i18n="@@validation.errors.first_name_greater_than_2_character" *ngIf="(submitted || clientForm.get('first_name').dirty) && clientForm.get('first_name').errors?.minlength">First name must be greater than 2 characters</span>
						</fieldset>
					</div>

					<div>
						<label for="lastName" i18n="@@clients.last_name">Last Name</label>
						<fieldset [ngClass]="{ 'has-error': (submitted || clientForm.get('last_name').dirty) && clientForm.get('last_name')?.errors }">
							<input type="text" name="last_name" formControlName="last_name" placeholder="Last Name">
							<span class="field-error" i18n="@@validation.errors.last_name_less_than_100_character" *ngIf="(submitted || clientForm.get('last_name').dirty) && clientForm.get('last_name').errors?.maxlength">Last name must be less than 100 characters</span>
							<span class="field-error" i18n="@@validation.errors.last_name_greater_than_2_character" *ngIf="(submitted || clientForm.get('last_name').dirty) && clientForm.get('last_name').errors?.minlength">Last name must be greater than 2 characters</span>
						</fieldset>
					</div>

					<div>
						<label for="email" i18n="@@clients.email">Email</label>
						<fieldset [ngClass]="{ 'has-error': (submitted || clientForm.get('email').dirty) && clientForm.get('email')?.errors }">
							<input formControlName="email" name="email">
							<span class="field-error" i18n="@@error.required" *ngIf="(submitted || clientForm.get('email').dirty) && clientForm.get('email').errors?.required">Phone is required</span>
							<span class="field-error">{{clientForm.get('email').errors?.serverError}}</span>
						</fieldset>
					</div>

					<div>
						<label for="country_id" i18n="@@clients.country_name">Country <span class="req-star" style="display: unset;">*</span></label>
						<fieldset [ngClass]="{ 'has-error': clientForm.get('country_id').errors?.serverError ||  ((submitted || clientForm.get('country_id').dirty) && clientForm.get('country_id').errors) }">
							<select id="country_id" app-select2
								[options]="{ 	ajax: {url: countryListApi}, 	idColumn: 'id', 	textColumn: 'name' }"
								[selected]="selectedCountry ? {id: selectedCountry.id, text: selectedCountry.country_name} : null"
								(itemSelected)="onCountryChange($event)"
								i18n-placeholder="@@business.country_placeholder" placeholder="Please type country name"
								name="country_id" formControlName="country_id">
								<option></option>
							</select>
							<span class="field-error">{{clientForm.get('country_id').errors?.serverError}}</span>
						</fieldset>
					</div>

					<div>
						<label for="phone" i18n="@@clients.phone">Phone <span class="req-star" style="display: unset;">*</span></label>
						<fieldset [ngClass]="{ 'has-error': clientForm.get('phone').errors?.serverError || ((submitted || clientForm.get('phone').dirty) && clientForm.get('phone').errors) }" class="phone-fieldset">
							<div class="phone-input-wrapper">
								<input type="text" id="dial_code" name="dial_code" formControlName="dial_code" class="dial-code" readonly>
								<input type="tel" id="phone" name="phone" formControlName="phone" maxlength="10" i18n-placeholder="@@clients.client_phone" placeholder="Phone" class="phone-number">
							</div>
							<span class="field-error" i18n="@@error.required" *ngIf="(submitted || clientForm.get('phone').dirty) && clientForm.get('phone').errors?.required"> Phone is required </span>
							<span class="field-error"> {{ clientForm.get('phone').errors?.serverError }} </span>
						</fieldset>
					</div>

					<div>
						<label for="date_of_birth" i18n="@@clients.date_of_birth">Birth Date</label>
						<input type="date" id="date_of_birth" name="date_of_birth" formControlName="date_of_birth"
							placeholder="Select date" />
					</div>

					<div>
						<fieldset [ngClass]="{'has-error': submitted && clientForm.get('website').errors }">
							<label i18n="@@clients.website">Website</label>
							<input type="text" formControlName="website" name="website" />
							<span class="field-error" i18n="@@clients.validation.incorrect_url">Incorrect URL</span>
						</fieldset>
					</div>

					<div>
						<fieldset>
							<label i18n="@@clients.tax_reg_number">VAT registration Number</label>
							<input type="text" formControlName="tax_reg_number" name="tax-registration" />
						</fieldset>
					</div>

					<div>
						<fieldset>
							<label i18n="@@clients.cr_number">CR Number</label>
							<input type="text" formControlName="buyer_cr_number" name="buyer_cr_number" />
						</fieldset>
					</div>

					<div>
						<label for="address" i18n="@@clients.address">Address</label>
						<textarea type="text" formControlName="address" name="address"></textarea>
					</div>
				</div>
			</div>
		</form>
	</div>

	<div class="client_info_block" *ngIf="activeTab == 'view-client'">
		<div class="d-flex align-items-center justify-content-between w-100 flex-column flex-sm-row">
			<span i18n="@@clients.statement_of_account">Statement of account</span>
			<div class="d-flex align-items-center gap-2 flex-column flex-sm-row">
				<div class="field_cont">
					<div i18n="@@clients.from">
						from
					</div>
					<div class="field_cont custom-date-wrapper flex-column flex-sm-row">
						<input type="date" placeholder="Select date" class="date-input startDate"
							(change)="onDateChange($event, 'from')" />
						<svg class="custom-date-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
							viewBox="0 0 24 24" fill="none">
							<path
								d="M21 10H3M16 2V6M8 2V6M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z"
								stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
					</div>

					<span i18n="@@clients.to">
						to
					</span>
					<div class="field_cont custom-date-wrapper flex-column flex-sm-row">
						<input type="date" placeholder="Select date" class="date-input startDate"
							(change)="onDateChange($event, 'to')" />
						<svg class="custom-date-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
							viewBox="0 0 24 24" fill="none">
							<path
								d="M21 10H3M16 2V6M8 2V6M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z"
								stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
					</div>
				</div>
				<div class="custom_select downloader d-flex flex-column flex-sm-row">
					<div class="custom_select-header" [class.disabled]="!projects || projects.length === 0"
						(click)="(projects && projects.length > 0) ? toggleDropdown($event) : null">
						<div>
							<div i18n="@@clients.download_as">
								Download as
							</div>
						</div>
						<div class="custom_select-icon">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
								fill="none">
								<path d="M6 9L12 15L18 9" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
									stroke-linejoin="round" />
							</svg>
						</div>
					</div>
					<div class="custom_select-content">
						<div class="custom_select-item downloadAsPDF" (click)="downloadPDF()">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17"
								fill="none">
								<path d="M6 7.83333V11.8333L7.33333 10.5" stroke="#646464" stroke-width="1.5"
									stroke-linecap="round" stroke-linejoin="round" />
								<path d="M6.00002 11.8333L4.66669 10.5" stroke="#646464" stroke-width="1.5"
									stroke-linecap="round" stroke-linejoin="round" />
								<path
									d="M14.6666 7.16666V10.5C14.6666 13.8333 13.3333 15.1667 9.99998 15.1667H5.99998C2.66665 15.1667 1.33331 13.8333 1.33331 10.5V6.5C1.33331 3.16666 2.66665 1.83333 5.99998 1.83333H9.33331"
									stroke="#646464" stroke-width="1.5" stroke-linecap="round"
									stroke-linejoin="round" />
								<path
									d="M14.6667 7.16666H12C10 7.16666 9.33337 6.49999 9.33337 4.49999V1.83333L14.6667 7.16666Z"
									stroke="#646464" stroke-width="1.5" stroke-linecap="round"
									stroke-linejoin="round" />
							</svg>
							<span i18n="@@clients.pdf">
								PDF
							</span>
						</div>
						<div class="custom_select-item downloadAsXLSX" (click)="downloadExcel()">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17"
								fill="none">
								<path d="M6 7.83333V11.8333L7.33333 10.5" stroke="#646464" stroke-width="1.5"
									stroke-linecap="round" stroke-linejoin="round" />
								<path d="M6.00002 11.8333L4.66669 10.5" stroke="#646464" stroke-width="1.5"
									stroke-linecap="round" stroke-linejoin="round" />
								<path
									d="M14.6666 7.16666V10.5C14.6666 13.8333 13.3333 15.1667 9.99998 15.1667H5.99998C2.66665 15.1667 1.33331 13.8333 1.33331 10.5V6.5C1.33331 3.16666 2.66665 1.83333 5.99998 1.83333H9.33331"
									stroke="#646464" stroke-width="1.5" stroke-linecap="round"
									stroke-linejoin="round" />
								<path
									d="M14.6667 7.16666H12C10 7.16666 9.33337 6.49999 9.33337 4.49999V1.83333L14.6667 7.16666Z"
									stroke="#646464" stroke-width="1.5" stroke-linecap="round"
									stroke-linejoin="round" />
							</svg>
							<span i18n="@@clients.xlsx">
								XLSX
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<table class="marketing_table" id="activatedTable">
			<thead>
				<tr>
					<th i18n="@@clients.invoice">Invoice</th>
					<th i18n="@@clients.status">Status</th>
					<th i18n="@@clients.date">Date</th>
					<th i18n="@@clients.amount">Amount</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let project of projects">
					<td data-label="Invoice"><span>#{{ project.invoice_number }}</span>
						<div class="position-absolute d-none-block d-none" style="top: 3px;right: 10px;">
							<div class="options-menu" *ngIf="project.showOptions">
								<button type="button" *ngIf='(project.tax_type == 3 || (project.tax_type == null && !project.tax_percent) || project.is_draft) && project.status != "paid"' (click)="orderActions('edit_invoice', project.uuid)" class="edit-option edit-invoice open_b2b_invoice">
									<svg class="edit-invoice" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
										<path d="M13.6666 7.53324V4.69326C13.6666 2.00659 13.0399 1.33325 10.5199 1.33325H5.47992C2.95992 1.33325 2.33325 2.00659 2.33325 4.69326V12.1999C2.33325 13.9732 3.30659 14.3933 4.48659 13.1266L4.49325 13.1199C5.03991 12.5399 5.87324 12.5866 6.34658 13.2199L7.01992 14.1199" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
										<path d="M5.33325 4.66675H10.6666" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
										<path d="M6 7.33325H10" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
										<path d="M12.1408 9.84685L9.78077 12.2069C9.68743 12.3002 9.60075 12.4735 9.58075 12.6002L9.45409 13.5002C9.40742 13.8269 9.63409 14.0535 9.96076 14.0069L10.8608 13.8802C10.9874 13.8602 11.1674 13.7735 11.2541 13.6802L13.6141 11.3202C14.0208 10.9135 14.2141 10.4402 13.6141 9.8402C13.0208 9.24686 12.5474 9.44018 12.1408 9.84685Z" stroke="#646464" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
										<path d="M11.7996 10.1868C11.9996 10.9068 12.5596 11.4668 13.2796 11.6668" stroke="#646464" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
									</svg>
									<span i18n="@@dashboard.edit">
										Edit
									</span>
								</button>
								<button type="button" class="edit-option" (click)="pdfInvoice(project.uuid)">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
										<path d="M6 7.33325V11.3333L7.33333 9.99992" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										<path d="M6.00008 11.3333L4.66675 10" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										<path d="M14.6666 6.66659V9.99992C14.6666 13.3333 13.3333 14.6666 9.99992 14.6666H5.99992C2.66659 14.6666 1.33325 13.3333 1.33325 9.99992V5.99992C1.33325 2.66659 2.66659 1.33325 5.99992 1.33325H9.33325" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										<path d="M14.6666 6.66658H11.9999C9.99992 6.66658 9.33325 5.99992 9.33325 3.99992V1.33325L14.6666 6.66658Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<span i18n="@@dashboard.pdf_download">PDF Download</span>
								</button>
								<button type="button" class="edit-option" *ngIf="project.email" (click)="emailInvoices([project.uuid])">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
										<path d="M11.3066 4.11328C12.64 5.03995 13.56 6.51328 13.7466 8.21328" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										<path d="M2.32666 8.24673C2.49999 6.5534 3.40666 5.08006 4.72666 4.14673" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										<path d="M5.45996 13.96C6.23329 14.3533 7.11329 14.5733 8.03996 14.5733C8.93329 14.5733 9.77329 14.3733 10.5266 14.0066" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										<path d="M8.0401 5.13342C9.06367 5.13342 9.89343 4.30366 9.89343 3.28009C9.89343 2.25652 9.06367 1.42676 8.0401 1.42676C7.01653 1.42676 6.18677 2.25652 6.18677 3.28009C6.18677 4.30366 7.01653 5.13342 8.0401 5.13342Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										<path d="M3.22003 13.2799C4.2436 13.2799 5.07337 12.4501 5.07337 11.4266C5.07337 10.403 4.2436 9.57324 3.22003 9.57324C2.19646 9.57324 1.3667 10.403 1.3667 11.4266C1.3667 12.4501 2.19646 13.2799 3.22003 13.2799Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										<path d="M12.7801 13.2799C13.8037 13.2799 14.6334 12.4501 14.6334 11.4266C14.6334 10.403 13.8037 9.57324 12.7801 9.57324C11.7565 9.57324 10.9268 10.403 10.9268 11.4266C10.9268 12.4501 11.7565 13.2799 12.7801 13.2799Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<span i18n="@@dashboard.send_share">Send via Email</span>
								</button>
								<button type="button" class="edit-option" (click)="whatsappInvoices([project.uuid])">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
										<path d="M11.3066 4.11328C12.64 5.03995 13.56 6.51328 13.7466 8.21328" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										<path d="M2.32666 8.24673C2.49999 6.5534 3.40666 5.08006 4.72666 4.14673" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										<path d="M5.45996 13.96C6.23329 14.3533 7.11329 14.5733 8.03996 14.5733C8.93329 14.5733 9.77329 14.3733 10.5266 14.0066" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										<path d="M8.0401 5.13342C9.06367 5.13342 9.89343 4.30366 9.89343 3.28009C9.89343 2.25652 9.06367 1.42676 8.0401 1.42676C7.01653 1.42676 6.18677 2.25652 6.18677 3.28009C6.18677 4.30366 7.01653 5.13342 8.0401 5.13342Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										<path d="M3.22003 13.2799C4.2436 13.2799 5.07337 12.4501 5.07337 11.4266C5.07337 10.403 4.2436 9.57324 3.22003 9.57324C2.19646 9.57324 1.3667 10.403 1.3667 11.4266C1.3667 12.4501 2.19646 13.2799 3.22003 13.2799Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										<path d="M12.7801 13.2799C13.8037 13.2799 14.6334 12.4501 14.6334 11.4266C14.6334 10.403 13.8037 9.57324 12.7801 9.57324C11.7565 9.57324 10.9268 10.403 10.9268 11.4266C10.9268 12.4501 11.7565 13.2799 12.7801 13.2799Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<span i18n="@@dashboard.send_share">Send via Whatsapp</span>
								</button>
								<button type="button" *ngIf='(project.tax_type == 3 || (project.tax_type == null && !project.tax_percent) || project.is_draft) && project.status != "paid"' (click)="deleteInvoices([project.uuid])" class="edit-option edit-invoice open_b2b_invoice">
									<svg class="delete-invoice" xmlns="http://www.w3.org/2000/svg" width="16"
										height="16" viewBox="0 0 16 16" fill="none">
										<path d="M14 3.98665C11.78 3.76665 9.54667 3.65332 7.32 3.65332C6 3.65332 4.68 3.71999 3.36 3.85332L2 3.98665" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
										<path d="M5.66675 3.31325L5.81341 2.43992C5.92008 1.80659 6.00008 1.33325 7.12675 1.33325H8.87341C10.0001 1.33325 10.0867 1.83325 10.1867 2.44659L10.3334 3.31325" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
										<path d="M12.5667 6.09326L12.1334 12.8066C12.06 13.8533 12 14.6666 10.14 14.6666H5.86002C4.00002 14.6666 3.94002 13.8533 3.86668 12.8066L3.43335 6.09326" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
										<path d="M6.88672 11H9.10672" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
										<path d="M6.33325 8.33325H9.66659" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
									</svg>
									<span i18n="@@dashboard.delete">
										Delete
									</span>
								</button>
							</div>
							<div class="dots_container-rounded w-100 asd"
								(click)="toggleOptionsMenu(project.invoice_number)">
								<svg class="dots-menu" xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
									<path d="M9.5 9.75C9.91421 9.75 10.25 9.41421 10.25 9C10.25 8.58579 9.91421 8.25 9.5 8.25C9.08579 8.25 8.75 8.58579 8.75 9C8.75 9.41421 9.08579 9.75 9.5 9.75Z" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
									<path d="M9.5 4.5C9.91421 4.5 10.25 4.16421 10.25 3.75C10.25 3.33579 9.91421 3 9.5 3C9.08579 3 8.75 3.33579 8.75 3.75C8.75 4.16421 9.08579 4.5 9.5 4.5Z" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
									<path d="M9.5 15C9.91421 15 10.25 14.6642 10.25 14.25C10.25 13.8358 9.91421 13.5 9.5 13.5C9.08579 13.5 8.75 13.8358 8.75 14.25C8.75 14.6642 9.08579 15 9.5 15Z" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
							</div>
						</div>
					</td>
					<td data-label="Status" class="status">
						<div class="order_status" [ngClass]="getOrderStatusClass(project)">
							<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
								<circle cx="4" cy="4" r="4" [attr.fill]="getCircleColor(project)" />
							</svg>
							{{ getOrderStatusText(project) }}
						</div>
					</td>
					<td data-label="Date">
						<span>
							{{ project.invoice_date | date:'d.MM.yyyy' }}
						</span>
					</td>
					<td data-label="Amount" class="border-bottom-none-0"><span
							[innerHtml]="project.paid_amount | myCurrency"></span></td>
					<td data-label="" class="d-none-none">
						<div class="position-relative">
							<div class="options-menu" *ngIf="project.showOptions">

								<!-- <button class="edit-option open_b2b_invoice">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
										<path d="M13.6666 7.53324V4.69326C13.6666 2.00659 13.0399 1.33325 10.5199 1.33325H5.47992C2.95992 1.33325 2.33325 2.00659 2.33325 4.69326V12.1999C2.33325 13.9732 3.30659 14.3933 4.48659 13.1266L4.49325 13.1199C5.03991 12.5399 5.87324 12.5866 6.34658 13.2199L7.01992 14.1199" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M5.33325 4.66675H10.6666" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M6 7.33325H10" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M12.1408 9.84685L9.78077 12.2069C9.68743 12.3002 9.60075 12.4735 9.58075 12.6002L9.45409 13.5002C9.40742 13.8269 9.63409 14.0535 9.96076 14.0069L10.8608 13.8802C10.9874 13.8602 11.1674 13.7735 11.2541 13.6802L13.6141 11.3202C14.0208 10.9135 14.2141 10.4402 13.6141 9.8402C13.0208 9.24686 12.5474 9.44018 12.1408 9.84685Z" stroke="#646464" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M11.7996 10.1868C11.9996 10.9068 12.5596 11.4668 13.2796 11.6668" stroke="#646464" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
									Edit
								</button>
								<button class="edit-option">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
										<path d="M6 7.33325V11.3333L7.33333 9.99992" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M6.00008 11.3333L4.66675 10" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M14.6666 6.66659V9.99992C14.6666 13.3333 13.3333 14.6666 9.99992 14.6666H5.99992C2.66659 14.6666 1.33325 13.3333 1.33325 9.99992V5.99992C1.33325 2.66659 2.66659 1.33325 5.99992 1.33325H9.33325" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M14.6666 6.66658H11.9999C9.99992 6.66658 9.33325 5.99992 9.33325 3.99992V1.33325L14.6666 6.66658Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
									PDF Download
								</button>
								<button class="edit-option">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
										<path d="M11.3066 4.11328C12.64 5.03995 13.56 6.51328 13.7466 8.21328" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M2.32666 8.24673C2.49999 6.5534 3.40666 5.08006 4.72666 4.14673" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M5.45996 13.96C6.23329 14.3533 7.11329 14.5733 8.03996 14.5733C8.93329 14.5733 9.77329 14.3733 10.5266 14.0066" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M8.0401 5.13342C9.06367 5.13342 9.89343 4.30366 9.89343 3.28009C9.89343 2.25652 9.06367 1.42676 8.0401 1.42676C7.01653 1.42676 6.18677 2.25652 6.18677 3.28009C6.18677 4.30366 7.01653 5.13342 8.0401 5.13342Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M3.22003 13.2799C4.2436 13.2799 5.07337 12.4501 5.07337 11.4266C5.07337 10.403 4.2436 9.57324 3.22003 9.57324C2.19646 9.57324 1.3667 10.403 1.3667 11.4266C1.3667 12.4501 2.19646 13.2799 3.22003 13.2799Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M12.7801 13.2799C13.8037 13.2799 14.6334 12.4501 14.6334 11.4266C14.6334 10.403 13.8037 9.57324 12.7801 9.57324C11.7565 9.57324 10.9268 10.403 10.9268 11.4266C10.9268 12.4501 11.7565 13.2799 12.7801 13.2799Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
									Send/Share
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
										<path d="M5.93994 13.28L10.2866 8.9333C10.7999 8.41997 10.7999 7.57997 10.2866 7.06664L5.93994 2.71997" stroke="#646464" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
								</button>
								<button class="edit-option">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
										<path d="M14 3.98665C11.78 3.76665 9.54667 3.65332 7.32 3.65332C6 3.65332 4.68 3.71999 3.36 3.85332L2 3.98665" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M5.66675 3.31325L5.81341 2.43992C5.92008 1.80659 6.00008 1.33325 7.12675 1.33325H8.87341C10.0001 1.33325 10.0867 1.83325 10.1867 2.44659L10.3334 3.31325" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M12.5667 6.09326L12.1334 12.8066C12.06 13.8533 12 14.6666 10.14 14.6666H5.86002C4.00002 14.6666 3.94002 13.8533 3.86668 12.8066L3.43335 6.09326" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M6.88672 11H9.10672" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M6.33325 8.33325H9.66659" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
									Delete
								</button> -->
								<button type="button"
									*ngIf='(project.tax_type == 3 || (project.tax_type == null && !project.tax_percent) || project.is_draft) && project.status != "paid"'
									(click)="orderActions('edit_invoice', project.uuid)"
									class="edit-option edit-invoice open_b2b_invoice">
									<svg class="edit-invoice" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
										viewBox="0 0 16 16" fill="none">
										<path
											d="M13.6666 7.53324V4.69326C13.6666 2.00659 13.0399 1.33325 10.5199 1.33325H5.47992C2.95992 1.33325 2.33325 2.00659 2.33325 4.69326V12.1999C2.33325 13.9732 3.30659 14.3933 4.48659 13.1266L4.49325 13.1199C5.03991 12.5399 5.87324 12.5866 6.34658 13.2199L7.01992 14.1199"
											stroke="#646464" stroke-width="1.5" stroke-linecap="round"
											stroke-linejoin="round"></path>
										<path d="M5.33325 4.66675H10.6666" stroke="#646464" stroke-width="1.5"
											stroke-linecap="round" stroke-linejoin="round"></path>
										<path d="M6 7.33325H10" stroke="#646464" stroke-width="1.5"
											stroke-linecap="round" stroke-linejoin="round"></path>
										<path
											d="M12.1408 9.84685L9.78077 12.2069C9.68743 12.3002 9.60075 12.4735 9.58075 12.6002L9.45409 13.5002C9.40742 13.8269 9.63409 14.0535 9.96076 14.0069L10.8608 13.8802C10.9874 13.8602 11.1674 13.7735 11.2541 13.6802L13.6141 11.3202C14.0208 10.9135 14.2141 10.4402 13.6141 9.8402C13.0208 9.24686 12.5474 9.44018 12.1408 9.84685Z"
											stroke="#646464" stroke-width="1.5" stroke-miterlimit="10"
											stroke-linecap="round" stroke-linejoin="round"></path>
										<path d="M11.7996 10.1868C11.9996 10.9068 12.5596 11.4668 13.2796 11.6668"
											stroke="#646464" stroke-width="1.5" stroke-miterlimit="10"
											stroke-linecap="round" stroke-linejoin="round"></path>
									</svg>
									<span i18n="@@dashboard.edit">
										Edit
									</span>
								</button>
								<button type="button" class="edit-option" (click)="pdfInvoice(project.uuid)">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
										fill="none">
										<path d="M6 7.33325V11.3333L7.33333 9.99992" stroke="#646464" stroke-width="1.5"
											stroke-linecap="round" stroke-linejoin="round" />
										<path d="M6.00008 11.3333L4.66675 10" stroke="#646464" stroke-width="1.5"
											stroke-linecap="round" stroke-linejoin="round" />
										<path
											d="M14.6666 6.66659V9.99992C14.6666 13.3333 13.3333 14.6666 9.99992 14.6666H5.99992C2.66659 14.6666 1.33325 13.3333 1.33325 9.99992V5.99992C1.33325 2.66659 2.66659 1.33325 5.99992 1.33325H9.33325"
											stroke="#646464" stroke-width="1.5" stroke-linecap="round"
											stroke-linejoin="round" />
										<path
											d="M14.6666 6.66658H11.9999C9.99992 6.66658 9.33325 5.99992 9.33325 3.99992V1.33325L14.6666 6.66658Z"
											stroke="#646464" stroke-width="1.5" stroke-linecap="round"
											stroke-linejoin="round" />
									</svg>
									<span i18n="@@dashboard.pdf_download">PDF Download</span>
								</button>
								<button type="button" class="edit-option" *ngIf="project.email"
									(click)="emailInvoices([project.uuid])">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
										fill="none">
										<path d="M11.3066 4.11328C12.64 5.03995 13.56 6.51328 13.7466 8.21328"
											stroke="#646464" stroke-width="1.5" stroke-linecap="round"
											stroke-linejoin="round" />
										<path d="M2.32666 8.24673C2.49999 6.5534 3.40666 5.08006 4.72666 4.14673"
											stroke="#646464" stroke-width="1.5" stroke-linecap="round"
											stroke-linejoin="round" />
										<path
											d="M5.45996 13.96C6.23329 14.3533 7.11329 14.5733 8.03996 14.5733C8.93329 14.5733 9.77329 14.3733 10.5266 14.0066"
											stroke="#646464" stroke-width="1.5" stroke-linecap="round"
											stroke-linejoin="round" />
										<path
											d="M8.0401 5.13342C9.06367 5.13342 9.89343 4.30366 9.89343 3.28009C9.89343 2.25652 9.06367 1.42676 8.0401 1.42676C7.01653 1.42676 6.18677 2.25652 6.18677 3.28009C6.18677 4.30366 7.01653 5.13342 8.0401 5.13342Z"
											stroke="#646464" stroke-width="1.5" stroke-linecap="round"
											stroke-linejoin="round" />
										<path
											d="M3.22003 13.2799C4.2436 13.2799 5.07337 12.4501 5.07337 11.4266C5.07337 10.403 4.2436 9.57324 3.22003 9.57324C2.19646 9.57324 1.3667 10.403 1.3667 11.4266C1.3667 12.4501 2.19646 13.2799 3.22003 13.2799Z"
											stroke="#646464" stroke-width="1.5" stroke-linecap="round"
											stroke-linejoin="round" />
										<path
											d="M12.7801 13.2799C13.8037 13.2799 14.6334 12.4501 14.6334 11.4266C14.6334 10.403 13.8037 9.57324 12.7801 9.57324C11.7565 9.57324 10.9268 10.403 10.9268 11.4266C10.9268 12.4501 11.7565 13.2799 12.7801 13.2799Z"
											stroke="#646464" stroke-width="1.5" stroke-linecap="round"
											stroke-linejoin="round" />
									</svg>
									<span i18n="@@dashboard.send_share">Send via Email</span>
								</button>
								<button type="button" class="edit-option" (click)="whatsappInvoices([project.uuid])">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
										fill="none">
										<path d="M11.3066 4.11328C12.64 5.03995 13.56 6.51328 13.7466 8.21328"
											stroke="#646464" stroke-width="1.5" stroke-linecap="round"
											stroke-linejoin="round" />
										<path d="M2.32666 8.24673C2.49999 6.5534 3.40666 5.08006 4.72666 4.14673"
											stroke="#646464" stroke-width="1.5" stroke-linecap="round"
											stroke-linejoin="round" />
										<path
											d="M5.45996 13.96C6.23329 14.3533 7.11329 14.5733 8.03996 14.5733C8.93329 14.5733 9.77329 14.3733 10.5266 14.0066"
											stroke="#646464" stroke-width="1.5" stroke-linecap="round"
											stroke-linejoin="round" />
										<path
											d="M8.0401 5.13342C9.06367 5.13342 9.89343 4.30366 9.89343 3.28009C9.89343 2.25652 9.06367 1.42676 8.0401 1.42676C7.01653 1.42676 6.18677 2.25652 6.18677 3.28009C6.18677 4.30366 7.01653 5.13342 8.0401 5.13342Z"
											stroke="#646464" stroke-width="1.5" stroke-linecap="round"
											stroke-linejoin="round" />
										<path
											d="M3.22003 13.2799C4.2436 13.2799 5.07337 12.4501 5.07337 11.4266C5.07337 10.403 4.2436 9.57324 3.22003 9.57324C2.19646 9.57324 1.3667 10.403 1.3667 11.4266C1.3667 12.4501 2.19646 13.2799 3.22003 13.2799Z"
											stroke="#646464" stroke-width="1.5" stroke-linecap="round"
											stroke-linejoin="round" />
										<path
											d="M12.7801 13.2799C13.8037 13.2799 14.6334 12.4501 14.6334 11.4266C14.6334 10.403 13.8037 9.57324 12.7801 9.57324C11.7565 9.57324 10.9268 10.403 10.9268 11.4266C10.9268 12.4501 11.7565 13.2799 12.7801 13.2799Z"
											stroke="#646464" stroke-width="1.5" stroke-linecap="round"
											stroke-linejoin="round" />
									</svg>
									<span i18n="@@dashboard.send_share">Send via Whatsapp</span>
								</button>
								<button type="button"
									*ngIf='(project.tax_type == 3 || (project.tax_type == null && !project.tax_percent) || project.is_draft) && project.status != "paid"'
									(click)="deleteInvoices([project.uuid])"
									class="edit-option edit-invoice open_b2b_invoice">
									<svg class="delete-invoice" xmlns="http://www.w3.org/2000/svg" width="16"
										height="16" viewBox="0 0 16 16" fill="none">
										<path
											d="M14 3.98665C11.78 3.76665 9.54667 3.65332 7.32 3.65332C6 3.65332 4.68 3.71999 3.36 3.85332L2 3.98665"
											stroke="#646464" stroke-width="1.5" stroke-linecap="round"
											stroke-linejoin="round"></path>
										<path
											d="M5.66675 3.31325L5.81341 2.43992C5.92008 1.80659 6.00008 1.33325 7.12675 1.33325H8.87341C10.0001 1.33325 10.0867 1.83325 10.1867 2.44659L10.3334 3.31325"
											stroke="#646464" stroke-width="1.5" stroke-linecap="round"
											stroke-linejoin="round"></path>
										<path
											d="M12.5667 6.09326L12.1334 12.8066C12.06 13.8533 12 14.6666 10.14 14.6666H5.86002C4.00002 14.6666 3.94002 13.8533 3.86668 12.8066L3.43335 6.09326"
											stroke="#646464" stroke-width="1.5" stroke-linecap="round"
											stroke-linejoin="round"></path>
										<path d="M6.88672 11H9.10672" stroke="#646464" stroke-width="1.5"
											stroke-linecap="round" stroke-linejoin="round"></path>
										<path d="M6.33325 8.33325H9.66659" stroke="#646464" stroke-width="1.5"
											stroke-linecap="round" stroke-linejoin="round"></path>
									</svg>
									<span i18n="@@dashboard.delete">
										Delete
									</span>
								</button>
							</div>
							<div class="dots_container-rounded w-100"
								(click)="toggleOptionsMenu(project.invoice_number)">
								<svg class="dots-menu" xmlns="http://www.w3.org/2000/svg" width="19" height="18"
									viewBox="0 0 19 18" fill="none">
									<path
										d="M9.5 9.75C9.91421 9.75 10.25 9.41421 10.25 9C10.25 8.58579 9.91421 8.25 9.5 8.25C9.08579 8.25 8.75 8.58579 8.75 9C8.75 9.41421 9.08579 9.75 9.5 9.75Z"
										stroke="#393939" stroke-width="2" stroke-linecap="round"
										stroke-linejoin="round" />
									<path
										d="M9.5 4.5C9.91421 4.5 10.25 4.16421 10.25 3.75C10.25 3.33579 9.91421 3 9.5 3C9.08579 3 8.75 3.33579 8.75 3.75C8.75 4.16421 9.08579 4.5 9.5 4.5Z"
										stroke="#393939" stroke-width="2" stroke-linecap="round"
										stroke-linejoin="round" />
									<path
										d="M9.5 15C9.91421 15 10.25 14.6642 10.25 14.25C10.25 13.8358 9.91421 13.5 9.5 13.5C9.08579 13.5 8.75 13.8358 8.75 14.25C8.75 14.6642 9.08579 15 9.5 15Z"
										stroke="#393939" stroke-width="2" stroke-linecap="round"
										stroke-linejoin="round" />
								</svg>
							</div>
						</div>
					</td>
				</tr>
				<tr *ngIf="!projects || projects.length === 0">
					<td colspan="5" class="text-center">
						No invoices found
					</td>
				</tr>
			</tbody>
		</table>

		<!-- <div *ngIf="projects.length" class="text-center mt-3 d-flex justify-content-center">
			<a *ngIf="!loadingProjects; else loading" [hidden]="projectPaginator.isLast" (click)="projectPaginator.next()" class="tu-btn transparent cursor-pointer" i18n="@@common.load_more">Load More</a>
			<ng-template #loading>
				<p class="text-center" i18n="@@common.loading">Loading...</p>
			</ng-template>
		</div> -->

		<ng-container *ngIf="projectPaginator.totalItems > projectPaginator.itemsPerPage">
			<div class="pagination_wrapper">
				<div class="showing_results">
					<div class="select_wrapper">
						<ng-container i18n="@@show">Show</ng-container>
						<select class="select-link tab-links-select-invoice" id="tab-links-select-invoice" nice-select
							(change)="onChangeItemsPerPage($event)">
							<option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
						</select>
						<ng-container i18n="@@items">items</ng-container>
					</div>
					<div class="results_list" *ngIf="projectPaginator?.from || projectPaginator?.to">
						<ng-container i18n="@@showing_from">Showing from</ng-container> {{ projectPaginator?.from }}
						<ng-container i18n="@@to">to</ng-container> {{ projectPaginator?.to }} <ng-container
							i18n="@@of">of</ng-container> {{ projectPaginator?.totalItems }} <ng-container
							i18n="@@items">items</ng-container>
					</div>
				</div>
				<!-- <nav pagination-template #p="paginationApi" [id]="projectPaginator.id" (pageChange)="getProjects($event, true)" aria-label="...">
					<ul class="pagination justify-content-center">
						<li class="page-item" [class.disabled]="p.isFirstPage()">
							<a *ngIf="!p.isFirstPage()" class="page-link prev" tabindex="-1" (click)="p.previous()">
								<svg  width="7.5" height="13.5"><path d="M6.75 12.75l-6-6 6-6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg>
							</a>
						</li>

						<li *ngFor="let page of p.pages" class="page-item" [class.active]="p.getCurrent() === page.value" >
							<a *ngIf="p.getCurrent() !== page.value" (click)="p.setCurrent(page.value)" class="page-link">
								<span>{{ page.label }}</span>
							</a>
							<a *ngIf="p.getCurrent() === page.value" class="page-link">{{page.label}}
							<span class="sr-only">(current)</span></a>
						</li>
						
						<li class="page-item" [class.disabled]="p.isLastPage()">
							<a *ngIf="!p.isLastPage()" (click)="p.next()" class="page-link next">
								<svg width="7.5" height="13.5"><path d="M.75.75l6 6-6 6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg>
							</a>
						</li>
					</ul>
				</nav> -->

				<!-- <nav>
					<ul class="pagination">
					<li class="page-item" [class.disabled]="projectPaginator?.currentPage === 1">
						<a *ngIf="projectPaginator?.currentPage != 1" class="page-link prev" tabindex="-1"  (click)="prevPage()">
							<svg  width="7.5" height="13.5"><path d="M6.75 12.75l-6-6 6-6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg>
						</a>
					</li>

					<li class="page-item" 
						*ngFor="let page of [].constructor(totalPages()); let i = index"
						[class.active]="projectPaginator?.currentPage === i + 1">
					<a class="page-link" (click)="goToPage(i + 1)">{{ i + 1 }}</a>
					</li>

					<li class="page-item" [class.disabled]="projectPaginator?.currentPage === totalPages()">
						<a *ngIf="projectPaginator?.currentPage != totalPages()" (click)="nextPage()" class="page-link next">
							<svg width="7.5" height="13.5"><path d="M.75.75l6 6-6 6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg>
						</a>
					</li>
				</ul>
				</nav> -->
				<nav aria-label="Page navigation">
					<ul class="pagination justify-content-center">
						<li class="page-item" [class.disabled]="currentPage === 1">
							<a class="page-link prev" (click)="changePage(currentPage - 1)">
								<svg width="7.5" height="13.5">
									<path d="M6.75 12.75l-6-6 6-6" fill="none" class="color-stroke"
										stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
								</svg>
							</a>
						</li>

						<li *ngIf="paginationRange[0] > 1" class="page-item">
							<a class="page-link" (click)="changePage(1)">1</a>
						</li>

						<li *ngIf="paginationRange[0] > 1" class="page-item">
							<span class="page-link">...</span>
						</li>

						<li *ngFor="let page of paginationRange" class="page-item"
							[class.active]="page === currentPage">
							<a class="page-link" (click)="changePage(page)">{{ page }}</a>
						</li>

						<li *ngIf="paginationRange[paginationRange.length - 1] < totalPages" class="page-item">
							<span class="page-link">...</span>
						</li>

						<li *ngIf="paginationRange[paginationRange.length - 1] < totalPages" class="page-item">
							<a class="page-link" (click)="changePage(totalPages)">{{ totalPages }}</a>
						</li>

						<li class="page-item" [class.disabled]="currentPage === totalPages">
							<a class="page-link next" (click)="changePage(currentPage + 1)">
								<svg width="7.5" height="13.5">
									<path d="M.75.75l6 6-6 6" fill="none" class="color-stroke" stroke-linecap="round"
										stroke-linejoin="round" stroke-width="1.5" />
								</svg>
							</a>
						</li>
					</ul>
				</nav>
			</div>
		</ng-container>
	</div>
</div>

<!-- <div class="client-details">
	<div class="client-details__panel">

		<form *ngIf="editNameMode; else clientNameBlock" [formGroup]="editNameForm" class="client-details__form update-name"
			(ngSubmit)="onSubmitClientName()">

      		<fieldset class="half no-label" [ngClass]="{ 'has-error': (nameSubmitted || editNameForm.get('first_name').dirty) && editNameForm.get('first_name')?.errors }">
				<input type="first_name" name="first_name" formControlName="first_name" placeholder="First Name">
				<span class="field-error" i18n="@@clients.validation.first_name_required">First name is required</span>
        		<span class="field-error" i18n="@@validation.errors.enter_valid_first_name" *ngIf="(nameSubmitted || editNameForm.get('first_name').dirty) && editNameForm.get('first_name').errors?.pattern">Please enter valid first name</span>
			  	<span class="field-error" i18n="@@validation.errors.first_name_less_than_100_character" *ngIf="(nameSubmitted || editNameForm.get('first_name').dirty) && editNameForm.get('first_name').errors?.maxlength">First name must be less than 100 characters</span>
				<span class="field-error" i18n="@@validation.errors.first_name_greater_than_2_character" *ngIf="(nameSubmitted || editNameForm.get('first_name').dirty) && editNameForm.get('first_name').errors?.minlength">First name must be greater than 2 characters</span>
			</fieldset>

			<fieldset class="half no-label" [ngClass]="{ 'has-error': (nameSubmitted || editNameForm.get('last_name').dirty) && editNameForm.get('last_name')?.errors }">
				<input type="last_name" name="last_name" formControlName="last_name" placeholder="Last Name">
        		<span class="field-error" i18n="@@validation.errors.enter_valid_last_name" *ngIf="(nameSubmitted || editNameForm.get('last_name').dirty) && editNameForm.get('last_name').errors?.pattern">Please enter valid last name </span>
			  	<span class="field-error" i18n="@@validation.errors.last_name_less_than_100_character" *ngIf="(nameSubmitted || editNameForm.get('last_name').dirty) && editNameForm.get('last_name').errors?.maxlength">Last name must be less than 100 characters</span>
				<span class="field-error" i18n="@@validation.errors.last_name_greater_than_2_character" *ngIf="(nameSubmitted || editNameForm.get('last_name').dirty) && editNameForm.get('last_name').errors?.minlength">Last name must be greater than 2 characters</span>
				<span class="field-error" i18n="@@clients.validation.last_name_required">Last name is required</span>
			</fieldset>

			<button type="submit" class="tu-btn-circular pink addNewItem save-item active m-p-0">
				<svg width="14" height="14" viewBox="0 0 14 14">
					<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="square" stroke-width="2">
						<path d="M1 7h12M7 1v12"></path>
					</g>
				</svg>
			</button>
		</form>

		<ng-template #clientNameBlock>
			<div class="client-details__bio">
				<span class="client-details__bio--alpha">{{ getAcronym(clientDetail.full_name) }}</span>
				<span class="client-details__bio--name">{{ clientDetail.full_name }}
					<a (click)="onEditName()" class="client-details__bio--edit"></a>
				</span>
				<span class="client-details__bio--date">Since: July 2019</span>
			</div>
		</ng-template>

		<div class="client-details__btnControls">
			<a class="tu-btn pink text-white" (click)="sendInvoice()" i18n="@@clients.send_invoice">Send Invoice</a>
			<a href="javascript:void(0)" class="pink" (click)="deleteClient()" i18n="@@clients.delete_contact">Delete Contact</a>
		</div>
		<form [formGroup]="clientForm" class="client-details__form" (ngSubmit)="submitted=true; submit()">
			<fieldset class="half">
				<label i18n="@@clients.business_name" >Business Name</label>
				<input type="text" formControlName="business_name" name="company" />
			</fieldset>

			<fieldset class="half">
				<label i18n="@@clients.tax_reg_number">VAT registration Number</label>
				<input type="text" formControlName="tax_reg_number" name="tax-registration" />
			</fieldset>

			<fieldset class="half" [ngClass]="{'has-error': clientForm.get('country_id').errors?.serverError || ((submitted || clientForm.get('country_id').dirty) && clientForm.get('country_id').errors) }">
				<label i18n="@@clients.country_name">Country</label>
				<select
					app-select2
					[options]="{
						ajax: {url: countryListApi},
						idColumn: 'id',
						textColumn: 'name'
					}"
					[selected]="selectedCountry ? {id: selectedCountry.id, text: selectedCountry.country_name} : null"
					(itemSelected)="onCountryChange($event)"
				 	i18n-placeholder="@@business.country_placeholder" placeholder="Please type country name"
				 	name="country_id"
				 	formControlName="country_id"
			 	><option></option></select>
				<span class="field-error">{{clientForm.get('country_id').errors?.serverError}}</span>
			</fieldset>

			<fieldset class="half" [ngClass]="{'has-error': clientForm.get('phone').errors?.serverError || ((submitted || clientForm.get('phone').dirty) && clientForm.get('phone').errors) }">
				<label i18n="@@clients.client_phone">Phone</label>
				<div class="tel-input-group">
					<input type="text" formControlName="dial_code" id="countryCode" name="country_code" readonly
						class="dial-code">
					<input type="number" formControlName="phone" id="phone" i18n-placeholder="@@clients.client_phone" placeholder="Phone" name="phone" maxlength="10"
						class="phone-with-code">
					<span class="field-error" i18n="@@error.required" *ngIf="(submitted || clientForm.get('phone').dirty) && clientForm.get('phone').errors?.required">Phone is required</span>
					<span class="field-error">{{clientForm.get('phone').errors?.serverError}}</span>
				</div>
			</fieldset>

			<fieldset class="half" [ngClass]="{'has-error': clientForm.get('email').errors?.serverError || ((submitted || clientForm.get('email').dirty) && clientForm.get('email').errors) }">
				<label i18n="@@common.email">Email</label>
				<input type="text" formControlName="email" name="email" />
				<span class="field-error" i18n="@@error.valid_email" *ngIf="(submitted || clientForm.get('email').dirty) && clientForm.get('email').errors?.email">Please enter valid email address </span>
				<span class="field-error">{{clientForm.get('email').errors?.serverError}}</span>
			</fieldset>

			<fieldset class="half" [ngClass]="{'has-error': submitted && clientForm.get('website').errors }">
				<label i18n="@@clients.website">Website</label>
				<input type="text" formControlName="website" name="website" />
				<span class="field-error" i18n="@@clients.validation.incorrect_url">Incorrect URL</span>
			</fieldset>

			<fieldset>
				<label i18n="@@clients.address">Address</label>
				<input type="text" formControlName="address" name="address" />
			</fieldset>

			<button type="submit" class="tu-btn transparent" i18n="@@clients.save">Save</button>
		</form>
	</div>

	<div class="client-details__panel">

		<div class="client-details__activity">
			<div class="client-details__activity--item">
				{{ activeProjectsCount }} <span i18n="@@clients.active_invoices">Active Invoices</span>
			</div>

			<div class="client-details__activity--item">
				{{ completedProjectsCount }} <span i18n="@@clients.completed_invoices">Completed Invoices</span>
			</div>

			<div class="client-details__activity--item">
				{{ totalEarnings }} <span i18n="@@clients.total_earnings">Total Earnings</span>
			</div>
		</div>
		<h2 i18n="@@clients.invoices_history">Invoices History</h2>

		<div *ngIf="projects && projects.length; else noProject" class="client-details__projectHistory">
			<div *ngFor="let project of projects"
				[ngClass]="{'inprogress': project.due_amount != 0, 'completed': project.due_amount == 0}"
				class="client-details__projectHistory--item inprogress">
				<div class="client-details__projectHistory--item--title">
					<a>#{{ project.invoice_number }}</a>
				</div>

				<div class="client-details__projectHistory--item--status">
					<a class="tu-btn">{{ project.due_amount == 0 ? 'Completed' : 'In Progress' }}</a>
					<span>
						<ng-container i18n="@@clients.total_amount_paid">Total Amount Paid:</ng-container>
						<span class="amount px-1" [innerHtml]="project.paid_amount | myCurrency"></span>
					</span>
				</div>

				<div class="client-details__projectHistory--item--date">
					<span class="day">{{ project.invoice_date | date:"dd" }}</span>
					<span class="month">{{ project.invoice_date | date:"MMM" }}</span>
				</div>
			</div>
		</div>

		<ng-template #noProject>
			<p class="text-center">
				<ng-container *ngIf="loadingProjects; else noRecord" i18n="@@common.loading">Loading...</ng-container>
        <ng-template #noRecord>
            <ng-container i18n="@@common.no_project_found">No invoice found.</ng-container>
        </ng-template>
			</p>
		</ng-template>

		<div *ngIf="projects.length" class="text-center mt-3">
			<a *ngIf="!loadingProjects; else loading" [hidden]="projectPaginator.isLast" (click)="projectPaginator.next()"
				class="tu-btn transparent cursor-pointer" i18n="@@common.load_more">Load More</a>

			<ng-template #loading>
      			<p class="text-center" i18n="@@common.loading">Loading...</p>
      		</ng-template>
		</div>
	</div>
</div> -->